export default {
    "inquiries": "yes",
    "categoryOpenedClosed": "closed",
    "maxfilter": "5",
    "selectedViewName": "quick-shopping",
    "showAttributesOnProductsPage": "yes",
    "attributesQuantityOnQuickView": "3",
    "showAllAttributesOnQuickView": undefined,
    "attributesQuantityOnListView": "3",
    "showAllAttributesOnListView": undefined,
    "showShortDesc": "no",
    "allowAddingToCartMultiVariantProductsOnProductsList": "yes",
    "showUnitRateOnCartPage": "yes",
    "showPoints": undefined,

    "loyaltyProgram": "yes",
    "headerERPCategoriesOrder": "no",
	"technicalBreak": "no",
    "minimalPrice": "minimalPriceYes",
	"sizeChart":"no",
	"variantsOfSizeChart":"sizeChart-banner",
	"sizeChartSiteID":"27",
	"productIsInCart": "productIsInCart-no",

    "productListFilters__Manufacturer": "Manufacturer_Yes",
    "productListFilters__Brand": "Brand_Yes",
    "productListFilters__Availability": "Availability_Yes",
    "productListFilters__Rate": "Rate_Yes",
    "productListFilters__Photos": "Photos_Yes",
    "productListFilters__Attributes": "Attributes_Yes",
    "productListFilters__Flags": "Flags_Yes",
    "filterOption": "filterOption-yes",

    "productDetailsManufacturer": "productDetailsManufacturer-yes",
    "productDetailsResponsiblePerson": "productDetailsResponsiblePerson-yes",
    "productDetailsBrand": "productDetailsBrand-yes",

    "grapicalVariantsPresentation": "Variants_No",
    "variantsGroupingAttribute": "Grouping_First",
    "grapicalVariantsPresentationColorsPL": "B\u0142\u0119kitny||#99CCFF|||Czerwony||#FF3300|||Niebieski||#3366FF|||Br\u0105zowy||#964b00|||Czarny||#000000|||Bia\u0142y||#FFFFFF|||Z\u0142oty||#ffd700|||R\u00f3\u017cowy||#ffc0cb|||Turkusowy||#76D7C4|||Pomara\u0144czowy||#fc9303|||Zielony||#008000|||Be\u017cowy||#c2b280|||Bordowy||#800000|||Ciemny szary||#909090|||Fioletowy||#87599d|||Granatowy||#000080|||Szary||#b4b4b4|||Zgni\u0142o zielony||#a5a542|||\u017b\u00f3\u0142ty||#ffef00|||Wielokolorowy||multicolor",
    "grapicalVariantsPresentationColorsEN": "Azure||#99CCFF|||Red||#FF3300|||Blue||#3366FF|||Brown||#964b00|||Black||#000000|||White||#FFFFFF|||Gold||#ffd700|||Pink||#ffc0cb|||Turquoise||#76D7C4|||Orange||#fc9303|||Green||#008000|||Beige||#c2b280|||Burgundy||#800000|||Dark grey||#909090|||Purple||#87599d|||Navy blue||#000080|||Gray||#b4b4b4|||Rotten green||#a5a542|||Yellow||#ffef00|||Multicolor||multicolor",
    "grapicalVariantsPresentationColorsDE": "Azurblau||#99CCFF|||Rot||#FF3300|||Blau||#3366FF|||Braun||#964b00|||Schwarz||#000000|||Wei\u00df||#FFFFFF|||Gold||#ffd700|||Rosa||#ffc0cb|||T\u00fcrkis||#76D7C4|||Orange||#fc9303|||Gr\u00fcn||#008000|||Beige||#c2b280|||Kastanienbraun||#800000|||Dunkelgrau\u00e9||#909090|||Violett||#87599d|||Marineblau||#000080|||Grau||#b4b4b4|||Fauliges Gr\u00fcn||#a5a542|||Gelb||#ffef00|||Mehrfarbig||multicolor",
    "grapicalVariantsPresentationColorsFR": "Azur||#99CCFF|||Rouge||#FF3300|||Bleu||#3366FF|||Marron||#964b00|||Noir||#000000|||Blanc||#FFFFFF|||Or||#ffd700|||Rose||#ffc0cb|||Turquoise||#76D7C4|||Orange||#fc9303|||Vert||#008000|||Beige||#c2b280|||Bordeaux||#800000|||Gris fonc\u00e9||#909090|||Violet||#87599d|||Bleu marine||#000080|||Gris||#b4b4b4|||Vert pourri||#a5a542|||Jaune||#ffef00|||Multicolore||multicolor",
}